const doc = [({"da":({"js":({"admin":({"contacts":({"relations":({"relationship_was_removed":"Relation blev fjernet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;